import { FC, useMemo } from "react"
import { DLMSiteApplication } from "../../../../_models"
import { isPopulatedArray } from "../../../../../../../components/helpers"
import { DetailFileDownload, extractROIDetailFiles } from "../../../../../../../components/layout"
import { useAuth } from "../../../../../../auth"

type Props = {
  site: DLMSiteApplication
}

const DLMSiteApplicationsROICell: FC<Props> = ({site}) => {
  const { hasRole } = useAuth();

  const roiFiles = useMemo(() => {

    if (! ( site?.rois && isPopulatedArray(site.rois) && site?.dlmApplication && site.dlmApplication?.id)) {
      return [];
    }

    return extractROIDetailFiles(site.rois, site.dlmApplication.id);

  }, [site]);

  if (! (roiFiles && roiFiles.length > 0)) {
    return null;
  }

  return (
  <>
  {
  roiFiles.map((dat: any, idx: number) => (
  <div key={`roiFile-${idx}`}>    
    <DetailFileDownload key={`showfile${idx}`} labelText={dat.showFileTitle} file={dat.showFile} setscoOnly={false} hasChanged={dat.hasChanged} data={dat} canReplace={hasRole('Super Admin')}/>
  </div>
  ))
  }
  </>
  )
}

export { DLMSiteApplicationsROICell }